<template>
  <div class="padding-xl">
    <el-steps :active="1" align-center class="padding-tb-xl" process-status="finish">
      <el-step title="选择订户类型"></el-step>
      <el-step title="填写征订单（集体征订）"></el-step>
      <el-step title="订单支付"></el-step>
      <el-step title="发票开具"></el-step>
    </el-steps>
    <div class="solid-top padding-tb-xl">
      <div class="flex justify-between align-center">
        <div class="text-red text-lg flex justify-start align-center">
          <div class="flex justify-start align-center" v-if="serverConfig.subOrgEnabled===true">
            <div class="info-label">
              <div class="text-red text-xs padding-top-xs padding-right-xs"><i class="cuIcon-favorfill"></i></div>
              <div>归属区域：</div>
            </div>
            <div>
              <el-input @change="orgSelected" id="org_input" v-model="selectedOrgLabel"
                        @click.native="orgDialogShow = true"
                        size="small" style="width:160px"></el-input>
            </div>
          </div>
          <div class="flex justify-start align-center">
            <div class="info-label">
              <div class="text-red text-xs padding-top-xs padding-right-xs"><i class="cuIcon-favorfill"></i></div>
              <div>集体征订单位名称：</div>
            </div>
            <div>
              <el-input v-model="order.community" style="width:160px" size="small"></el-input>
            </div>
          </div>
          <div class="flex justify-start align-center" v-if="invoiceConfig.splitInvoice">
            <!--                      <el-switch v-model="withInvoiceInfo" @change="withInvoiceInfoChanged"></el-switch>-->
            <!--                      <div class="text-sm padding-left-sm">分开开票</div>-->
            <div class="info-label" style="width: 190px">
              <div class="text-red text-xs padding-top-xs padding-right-xs"><i class="cuIcon-favorfill"></i></div>
              <div>开票方式：</div>
            </div>
            <div>
              <el-select v-model="order.invoiceType" placeholder="请选择" size="small" style="width:160px">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="padding-right">合计金额：<span class="text-red">¥ {{ order.amount }}</span> 元</div>
      </div>
      <div class="text-red text-lg flex justify-start align-center padding-top">
        <div class="flex justify-start align-center">
          <div class="info-label">
            <div class="text-red text-xs padding-top-xs padding-right-xs"><i class="cuIcon-favorfill"></i></div>
            <div>经办人：</div>
          </div>
          <div>
            <el-input v-model="order.agent" style="width:160px" size="small"></el-input>
          </div>
        </div>
        <div class="flex justify-start align-center">
          <div class="info-label">
            <div class="text-red text-xs padding-top-xs padding-right-xs"><i class="cuIcon-favorfill"></i></div>
            <div>经办人手机：</div>
          </div>
          <div>
            <el-input v-model="order.agentPhone" style="width:160px" size="small"></el-input>
          </div>
        </div>
        <div class="flex justify-start align-center">
          <div class="info-label">
            <div class="text-red text-xs padding-top-xs padding-right-xs"><i class="cuIcon-favorfill"></i></div>
            <div>经办人座机：</div>
          </div>
          <div>
            <el-input v-model="order.agentTelephone" placeholder="如无座机，请填写‘无’" style="width:160px"
                      size="small"></el-input>
          </div>
        </div>
      </div>
      <div class="text-bold text-xxl padding-left flex padding-top">
        <button type="button" class="btn-danger round cu-btn bg-red" @click="download">
          <i class="cuIcon-down"></i><span class="padding-left-xs">下载模板</span>
        </button>
        <el-upload
          action=""
          :on-change="handlePreview"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          :limit="3"
          :show-file-list="false"
          :auto-upload="false">
          <button type="button" class=" btn-danger round cu-btn bg-red margin-lr"><i class="cuIcon-upload"></i><span
            class="padding-left-xs">上传模板数据</span></button>
        </el-upload>
        <span style="color: red; font-size: 14px; text-decoration: underline; font-weight: bold;">温馨提示：请根据下载模板正确填写数据，否则无法成功上传。</span>
      </div>
    </div>
    <div v-if="headers.length > 0">
      <el-table
        border
        :stripe="true"
        :data="page"
        :height="400"
        :max-height="400"
        :header-cell-style="headerStyle"
        :cell-style="cellStyle"
        :row-class-name="rowClassName"
        :row-style="{height: '40px',padding: '0'}"
        style="width: 100%">
        <el-table-column v-for="(item, index) in headers" :key="'f_' + index"
                         :prop="item.prop"
                         :label="item.label"
                         :width="item.width">
        </el-table-column>
        <el-table-column :label="item.label" v-for="(item, index) in headerGroups" :key="'j_' + index">
          <el-table-column v-for="(i, ind) in item.subs" :key="'k_' + ind"
                           :prop="i.prop"
                           :label="i.label"
                           :width="i.width">
          </el-table-column>
        </el-table-column>
      </el-table>
      <div class="padding-tb-xl">
        <el-pagination
          background
          :page-size="pageSize"
          @size-change="sizeChanged"
          @current-change="currentChanged"
          :current-page="currentPage"
          :page-sizes="[10, 20, 40, 80]"
          layout="total, sizes, prev, pager, next"
          :total="order.list.length">
        </el-pagination>
      </div>
    </div>
    <div v-else class="text-center text-lg" style="min-height:100px;padding-top:50px">
      暂无数据
    </div>
    <div class="padding-xl text-center">
      <button v-if="order.id" class="cu-btn bg-red round lg margin-lr" style="width:200px" @click="nav2List">查看订单列表
      </button>
      <button v-else class="cu-btn bg-red round lg margin-lr" style="width:200px" @click="$router.back()">上一步
      </button>
      <button class="cu-btn bg-red round lg margin-lr" style="width:200px" @click="addressTipShow = true">保存并支付
      </button>
    </div>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               :title="'请选择归属区域'"
               :visible.sync="orgDialogShow"
               width="30%">
      <div style="height: 400px;display: block; overflow-y: scroll">
        <el-tree
          :data="orgTree"
          :props="defaultProps"
          node-key="id"
          :default-expanded-keys="expandeds"
          accordion
          @node-click="handleNodeClick">
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orgDialogShow = false">取消</el-button>
        <el-button type="primary" @click="orgSelected">选择</el-button>
      </span>
    </el-dialog>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               :title="'温馨提示'"
               :visible.sync="addressTipShow"
               width="30%">
      <div>
        订阅明细中的收件地址需填写详细地址(省+地市+区县+详细地址)，您可以返回继续检查，如已确定征订数据无误可点击“继续支付”
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addressTipShow = false">重新填写</el-button>
        <el-button type="primary" @click="nextStep">继续支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import bs from '@/services/data/bs'
import config from '../../public/config/config'

export default {
  name: 'subscribe-multi',
  data () {
    return {
      addressTipShow: false,
      invoiceConfig: config.invoice,
      serverConfig: config.serverConfig,
      expandeds: [],
      selectedOrg: {},
      selectedOrgLabel: '',
      orgDialogShow: false,
      org: config.org,
      orgTree: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      submitting: false,
      currentPage: 1,
      pageSize: 10,
      products: [],
      productsMap: { '': { issue: null } },
      withInvoiceInfo: config.invoice.splitInvoice === true,
      order: {
        type: '集体订阅',
        community: '',
        amount: 0,
        state: 0,
        list: []
      },
      page: [],
      canPost: true,
      headers: [],
      headerGroups: [],
      tableData: [],
      options: [{
        value: 1,
        label: '开单张票'
      }, {
        value: 2,
        label: '开多张票'
      }]
    }
  },
  created () {
    this.user = JSON.parse(sessionStorage.getItem('user'))
    if (sessionStorage.getItem('products')) {
      this.products = JSON.parse(sessionStorage.getItem('products'))
      for (let i = 0; i < this.products.length; i++) {
        const p = this.products[i]
        this.productsMap[p.bookFullname] = p
      }
    }
    if (sessionStorage.getItem('order')) {
      this.order = JSON.parse(sessionStorage.getItem('order'))
      this.selectedOrgLabel = this.order.orgName
      this.withInvoiceInfo = this.order.withInvoiceInfo === 1
      const products = []
      const prodMap = {}
      for (let i = 0; i < this.order.list.length; i++) {
        if (!prodMap[this.order.list[i].product]) {
          prodMap[this.order.list[i].product] = { bookFullname: this.order.list[i].product }
          products.push(prodMap[this.order.list[i].product])
        }
      }
      const rowMap = {}
      for (let i = 0; i < this.order.list.length; i++) {
        const detail = this.order.list[i]
        let row = this.createTableRow(detail)

        const key = JSON.stringify(row)
        if (!rowMap[key]) {
          rowMap[key] = row
          this.tableData.push(row)
        } else {
          row = rowMap[key]
        }

        let k = 0
        let found = false
        for (; k < products.length; k++) {
          if (products[k].bookFullname === detail.product) {
            found = true
            break
          }
        }
        if (found) {
          const index = this.withInvoiceInfo ? 11 : 7
          row[index + k * 3] = detail.issueStart
          row[index + k * 3 + 1] = detail.issueEnd
          row[index + k * 3 + 2] = detail.qty
          row[(index + k * 3) + '_amount'] = detail.amount
        }
      }
      this.page = this.tableData.slice(0, this.pageSize)
      this.createHeaders(products)
    } else {
      this.createHeaders(this.products)
    }
    if (this.serverConfig.subOrgEnabled === true) {
      bs.data.org((res) => {
        this.orgTree.push(res.data)
        this.expandeds = [res.data.id]
      })
    }
  },
  methods: {
    withInvoiceInfoChanged (state) {
      this.createHeaders(this.products)
      if (state === true) {
        this.order.withInvoiceInfo = 1
      } else {
        delete this.order.withInvoiceInfo
      }
    },
    orgSelected () {
      this.order.orgId = this.selectedOrg.id
      this.order.orgName = this.selectedOrg.label
      this.selectedOrgLabel = this.selectedOrg.label
      this.orgDialogShow = false
    },
    handleNodeClick (data) {
      this.selectedOrg = data
    },
    createHeaders (products) {
      this.headers = []
      this.headerGroups = []
      let columnIndex = 0
      this.headers.push({
        prop: columnIndex + '',
        label: '征订年度',
        width: 100
      })
      columnIndex++
      this.headers.push({
        prop: columnIndex + '',
        label: '邮编（必填）',
        width: 150
      })
      columnIndex++
      this.headers.push({
        prop: columnIndex + '',
        label: '省（必填）',
        width: 150
      })
      columnIndex++
      this.headers.push({
        prop: columnIndex + '',
        label: '地市 (必填)',
        width: 150
      })
      columnIndex++
      this.headers.push({
        prop: columnIndex + '',
        label: '区县(街道) (必填)',
        width: 150
      })
      columnIndex++
      this.headers.push({
        prop: columnIndex + '',
        label: '收件地址（必填）',
        width: 320
      })
      columnIndex++
      this.headers.push({
        prop: columnIndex + '',
        label: '收件单位',
        width: 200
      })
      columnIndex++
      this.headers.push({
        prop: columnIndex + '',
        label: '收件人（必填）',
        width: 150
      })
      columnIndex++
      this.headers.push({
        prop: columnIndex + '',
        label: '联系电话（必填）',
        width: 120
      })
      columnIndex++

      if (this.withInvoiceInfo) {
        this.headerGroups.push({
          label: '开票信息',
          subs: [{
            prop: columnIndex + 0 + '',
            label: '购方名称',
            width: 90
          }, {
            prop: columnIndex + 1 + '',
            label: '购方税号',
            width: 90
          }, {
            prop: columnIndex + 2 + '',
            label: '推送手机',
            width: 90
          }, {
            prop: columnIndex + 3 + '',
            label: '推送邮箱',
            width: 90
          }]
        })
        columnIndex = columnIndex + 4
      }

      let step = 1
      if (config.ISSUE_RANGE) {
        step = 3
      }
      for (let i = 0, index = columnIndex; i < products.length; i = i + 1, index = index + step) {
        const group = {
          label: products[i].bookFullname,
          subs: []
        }
        if (config.ISSUE_RANGE) {
          group.subs.push({
            prop: index + '',
            label: '征订起始期',
            width: 130
          })

          group.subs.push({
            prop: (index + 1) + '',
            label: '征订结束期',
            width: 130
          })
        }
        group.subs.push({
          prop: (index + step - 1) + '',
          label: '份数',
          width: 100 - step * 10
        })
        group.subs.push({
          prop: index + '_amount',
          label: '金额',
          width: 120 - step * 10
        })
        this.headerGroups.push(group)
      }
    },
    nav2List () {
      this.$router.push({ path: '/pages/order-list' })
    },
    currentChanged (pageNumber) {
      this.currentPage = pageNumber
      this.page = this.tableData.slice((pageNumber - 1) * this.pageSize, pageNumber * this.pageSize)
    },
    sizeChanged (size) {
      this.currentPage = 1
      this.pageSize = size
      this.page = this.tableData.slice(0, this.pageSize)
    },
    handlePreview (file) {
      this.readXlsx(file.raw)
      this.resetTable()
    },
    resetTable () {
      this.currentPage = 1
      this.pageSize = 10
      this.order.type = '集体订阅'
      this.order.amount = 0
      this.order.state = 0
      this.order.list = []
      this.page = []
      this.canPost = true
    },
    nextStep () {
      this.addressTipShow = false
      if (this.submitting === true) {
        return
      } else {
        this.submitting = true
      }
      if (this.serverConfig.subOrgEnabled === true && this.selectedOrgLabel === '') {
        this.$message.error('请选择归属区域')
        this.submitting = false
      } else if (!this.order.community || this.order.community.trim() === '') {
        this.$message.error('请填写集体征订单位名称')
        this.submitting = false
      } else if (!this.order.agent || this.order.agent.trim() === '') {
        this.$message.error('请填写经办人')
        this.submitting = false
      } else if (!this.order.agentPhone || this.order.agentPhone.trim() === '') {
        this.$message.error('请填写经办人手机')
        this.submitting = false
      } else if (!this.order.agentTelephone || this.order.agentTelephone.trim() === '') {
        this.$message.error('请填写经办人座机')
        this.submitting = false
      } else if (this.invoiceConfig.splitInvoice && !this.order.invoiceType) {
        this.$message.error('请选择开票方式')
        this.submitting = false
      } else if (this.order.list.length < 1) {
        this.$message.error('没有可保存的数据')
        this.submitting = false
      } else if (!this.canPost) {
        this.$message.error('清单中包含无效数据，请查看清单中红色字体数据')
        this.submitting = false
      } else {
        bs.order.save(this.order, false, (res) => {
          if (res.code === 200) {
            sessionStorage.setItem('order', JSON.stringify(res.data))
            this.$message({
              message: '订单信息保存成功',
              type: 'success'
            })
            this.submitting = false
            this.$router.push({ path: '/pages/subscribe/pay' })
          } else if (res.code === 300) {
            this.$message.error(res.error)
          }
          this.submitting = false
        })
      }
    },
    rowClassName (obj) {
      if (!obj.row.valid) {
        return 'text-red'
      }
    },
    headerStyle (obj) {
      let rtn = 'text-align:center;font-size:14px;padding:6px 0'
      if (obj.rowIndex === 0 && obj.columnIndex >= (this.withInvoiceInfo ? 11 : 7) && !this.productsMap[obj.column.label]) {
        rtn = rtn + ';color:#666666'
      } else {
        rtn = rtn + ';color:#666666'
      }
      return rtn
    },
    cellStyle (obj) {
      let rtn = 'padding:0;'
      if (obj.columnIndex !== 2 && obj.columnIndex !== 1) {
        rtn = rtn + 'text-align:center'
      }
      return rtn
    },
    readXlsx (file) {
      const reader = new FileReader()
      reader.onload = e => {
        const data = e.target.result
        const workbook = XLSX.read(data, { type: 'binary' })
        this.processXlsx(workbook)
      }
      reader.readAsBinaryString(file)
    },
    processXlsx (workbook) {
      const data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], { header: 1 })
      const detailList = []
      let hasError = false
      for (let i = 2; i < data.length; i++) {
        const d = data[i]
        if ((!d[0] || d[0] === '') && (!d[5] || d[5] === '') && (!d[7] || d[7] === '') && (!d[2] || d[2] === '')) {
          continue
        }
        d.valid = this.processRow(d, i - 1)
        if (!d.valid) {
          hasError = true
        }
        detailList.push(d)
      }
      this.canPost = true
      this.tableData = detailList
      this.page = this.tableData.slice(0, this.pageSize)
      if (hasError) {
        this.$message.error('清单中包含无效数据，请查看清单中红色字体数据')
        this.canPost = false
      }
    },
    createOrderDetail (row, rowNo) {
      if (this.withInvoiceInfo) {
        return {
          rowNo: rowNo,
          seq: row['0'],
          addressZip: row['1'],
          addressProvinceName: row['2'],
          addressCityName: row['3'],
          addressDistrictName: row['4'],
          addressStreet: row['5'],
          addressOrg: row['6'],
          addressPerson: row['7'],
          addressPhone: row['8'],
          invoiceOrg: row['9'],
          invoiceTaxTin: row['10'],
          invoicePhone: row['11'],
          invoiceEmail: row['12']
        }
      }
      return {
        rowNo: rowNo,
        seq: row['0'],
        addressZip: row['1'],
        addressProvinceName: row['2'],
        addressCityName: row['3'],
        addressDistrictName: row['4'],
        addressStreet: row['5'],
        addressOrg: row['6'],
        addressPerson: row['7'],
        addressPhone: row['8']
      }
    },
    createTableRow (detail) {
      if (this.withInvoiceInfo) {
        return {
          0: detail.seq,
          1: detail.addressZip,
          2: detail.addressProvinceName,
          3: detail.addressCityName,
          4: detail.addressDistrictName,
          5: detail.addressStreet,
          6: detail.addressOrg,
          7: detail.addressPerson,
          8: detail.addressPhone,
          9: detail.invoiceOrg,
          10: detail.invoiceTaxTin,
          11: detail.invoicePhone,
          12: detail.invoiceEmail,
          valid: true
        }
      }
      return {
        0: detail.seq,
        1: detail.addressZip,
        2: detail.addressProvinceName,
        3: detail.addressCityName,
        4: detail.addressDistrictName,
        5: detail.addressStreet,
        6: detail.addressOrg,
        7: detail.addressPerson,
        8: detail.addressPhone,
        valid: true
      }
    },
    processRow (row, rowNo) {
      let isValid = true
      let qtyIndex = 0
      if (config.ISSUE_RANGE) {
        qtyIndex = 2
      }

      if ((!row[0] || row[0] === '') || (!row[2] || row[2] === '') || (!row[5] || row[5] === '') || (!row[7] || row[7] === '')) {
        isValid = false
      }

      for (let j = this.withInvoiceInfo ? 1 : 0; j < this.headerGroups.length; j++) {
        const group = this.headerGroups[j]
        if (!row[1] && !row[2] && !row[3] && !row[4]) {
          continue
        }
        if (row[group.subs[0].prop] && isNaN(row[group.subs[0].prop])) {
          row[group.subs[0].prop] = parseInt(row[group.subs[0].prop].replace(/[^0-9]/ig, ''))
        }

        if (group.subs.length > 2) {
          if (row[group.subs[1].prop] && isNaN(row[group.subs[1].prop])) {
            row[group.subs[1].prop] = parseInt(row[group.subs[1].prop].replace(/[^0-9]/ig, ''))
          }
          if (row[group.subs[2].prop] && isNaN(row[group.subs[2].prop])) {
            row[group.subs[2].prop] = parseInt(row[group.subs[2].prop].replace(/[^0-9]/ig, ''))
          }
        }

        if ((group.subs.length > 2 && row[group.subs[2].prop] > 0) || row[group.subs[0].prop] > 0) {
          const product = this.productsMap[group.label]
          let pass = true
          const rowProduct = this.createOrderDetail(row, rowNo)
          rowProduct.product = group.label
          if (product) {
            rowProduct.price = product.bookPrice
            rowProduct.itemCode = product.invoiceItemCode
            rowProduct.productId = product.prodId
            rowProduct.year = product.zdyrear
            if (config.ISSUE_RANGE) {
              if (isNaN(row[group.subs[0].prop]) || row[group.subs[0].prop] < 1 || row[group.subs[0].prop] > row[group.subs[1].prop] || row[group.subs[0].prop] > product.bookQs) {
                pass = false
              }
              if (isNaN(row[group.subs[1].prop]) || row[group.subs[1].prop] < 1 || row[group.subs[1].prop] > product.bookQs) {
                pass = false
              }
            }
            // row[group.subs[qtyIndex].prop] = row[group.subs[qtyIndex].prop].replace(/[^0-9]/ig, '')
            if (isNaN(row[group.subs[qtyIndex].prop])) {
              pass = false
            }
          } else {
            pass = false
          }
          if (product && pass) {
            let amount = 0
            if (config.ISSUE_RANGE) {
              amount = parseFloat((product.bookPrice * (row[group.subs[1].prop] - row[group.subs[0].prop] + 1) * row[group.subs[qtyIndex].prop]).toFixed(2))
            } else {
              amount = parseFloat((product.bookPrice * product.bookQs * row[group.subs[qtyIndex].prop]).toFixed(2))
            }
            row[group.subs[0].prop + '_amount'] = amount
            this.order.amount = this.order.amount + amount
            row.amount = row.amount + amount
            if (config.ISSUE_RANGE) {
              rowProduct.issueStart = row[group.subs[0].prop]
              rowProduct.issueEnd = row[group.subs[1].prop]
            } else {
              rowProduct.issueStart = 1
              rowProduct.issueEnd = product.bookQs
            }
            rowProduct.qty = row[group.subs[qtyIndex].prop]
            rowProduct.amount = amount
          }
          if (isValid && !pass) {
            isValid = false
          }
          if (isValid) {
            this.order.list.push(rowProduct)
          }
        }
      }
      return isValid
    },
    createXLSXHeaders () {
      const headers = []
      const firstHeaderRow = []
      const secondHeaderRow = []
      const thirdHeaderRow = []
      firstHeaderRow.push('征订年度')
      secondHeaderRow.push('')
      thirdHeaderRow.push('2027')

      firstHeaderRow.push('邮编（必填）')
      secondHeaderRow.push('')
      thirdHeaderRow.push('100080')

      firstHeaderRow.push('省（必填）')
      secondHeaderRow.push('')
      thirdHeaderRow.push('北京市')

      firstHeaderRow.push('地市 (必填)')
      secondHeaderRow.push('')
      thirdHeaderRow.push('海淀区')

      firstHeaderRow.push('区县(街道) (必填)')
      secondHeaderRow.push('')
      thirdHeaderRow.push('长春桥6号国家行政学院东门')

      firstHeaderRow.push('收件地址（必填）')
      secondHeaderRow.push('')
      thirdHeaderRow.push('北京市海淀区长春桥6号国家行政学院东门')

      firstHeaderRow.push('收件单位（必填）')
      secondHeaderRow.push('')
      thirdHeaderRow.push('国家行政学院')

      firstHeaderRow.push('收件人（必填）')
      secondHeaderRow.push('')
      thirdHeaderRow.push('小王')

      firstHeaderRow.push('联系电话（必填）')
      secondHeaderRow.push('')
      thirdHeaderRow.push('13888888888')

      if (this.withInvoiceInfo) {
        firstHeaderRow.push('开票信息')
        firstHeaderRow.push('')
        firstHeaderRow.push('')
        firstHeaderRow.push('')
        secondHeaderRow.push('购方名称')
        secondHeaderRow.push('购方税号')
        secondHeaderRow.push('推送手机')
        secondHeaderRow.push('推送邮箱')
      }
      let step = 1
      if (config.ISSUE_RANGE) {
        step = 3
      }
      for (let i = 0, index = (this.withInvoiceInfo ? 13 : 9); i < this.products.length; i = i + 1, index = index + step) {
        firstHeaderRow.push(this.products[i].bookFullname)
        if (step > 1) {
          firstHeaderRow.push('')
          firstHeaderRow.push('')
          secondHeaderRow.push('征订起始期')
          secondHeaderRow.push('征订结束期')
        }
        secondHeaderRow.push('份数')
        thirdHeaderRow.push('1')
      }

      headers.push(firstHeaderRow)
      headers.push(secondHeaderRow)
      headers.push(thirdHeaderRow)
      return headers
    },
    getXLSXDataMerges () {
      const dataMerges = []
      let i = 0
      for (; i < 9; i++) {
        dataMerges.push({
          s: {
            c: i,
            r: 0
          },
          e: {
            c: i,
            r: 1
          }
        })
      }
      if (this.withInvoiceInfo) {
        dataMerges.push({
          s: {
            c: i,
            r: 0
          },
          e: {
            c: i + 3,
            r: 0
          }
        })
        i = i + 4
      }
      if (config.ISSUE_RANGE) {
        for (let j = 0, index = i; j < this.products.length; j = j + 1, index = index + 3) {
          dataMerges.push({
            s: {
              c: index,
              r: 0
            },
            e: {
              c: index + 2,
              r: 0
            }
          })
        }
      }

      return dataMerges
    },
    download () {
      const ws = XLSX.utils.book_new()
      const data = this.createXLSXHeaders()
      const styles = data.map((row, rowIndex) =>
        row.map((cell, colIndex) =>
          rowIndex === 2 ? {
            v: cell,
            s: { fill: { fgColor: { rgb: 'FFFF00' } } }
          } : cell
        )
      )
      const sheet = XLSX.utils.aoa_to_sheet(styles)
      sheet['!merges'] = this.getXLSXDataMerges()
      sheet['!cols'] = new Array(100).fill({ wpx: 100 })
      XLSX.utils.book_append_sheet(ws, sheet)
      XLSX.writeFile(ws, '订单导入模版' + (this.withInvoiceInfo ? '（含发票信息）' : '') + '.xlsx', { compression: true })
    }
  }
}
</script>

<style scoped>
.info-label {
  width: 190px;
  padding: 2px 0;
  text-align: right;
  display: flex;
  justify-content: flex-end;
}

</style>
<style>
#org_input {
  cursor: pointer;
  background-color: #fff;
  pointer-events: none;
}
</style>
